import { useMemo } from 'react';
import UICardActions from '@mui/material/CardActions';
import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/material/styles';
import { LinkButton } from '@backstage/core-components';
import { catalogApiRef, EntityRefLink } from '@backstage/plugin-catalog-react';
import { parseEntityRef } from '@backstage/catalog-model';
import { useCard } from '../../lib/context';
import { CardVariant, EntitySpec } from '../../lib/types';
import { useApi } from '@backstage/core-plugin-api';
import { useAsync } from 'react-use';

export const Owner = ({ owner }: { owner: string }) => {
  const catalogApi = useApi(catalogApiRef);

  const entityRef = parseEntityRef(owner, {
    defaultKind: 'Group',
    defaultNamespace: 'default',
  });

  const { value: entity, loading } = useAsync(async () => {
    return await catalogApi.getEntityByRef(entityRef);
  }, []);

  if (loading || !entity) {
    return <>&nbsp;</>;
  }

  return <EntityRefLink entityRef={entityRef} underline="none" />;
};

export const CardActions = () => {
  const theme = useTheme();
  const { entity, actionRoute, actionLabel, variant } = useCard();
  const spec: EntitySpec = useMemo(() => entity?.spec ?? {}, [entity?.spec]);

  let label = 'Explore';
  if (actionLabel) {
    label = actionLabel;
  } else if (entity?.kind === 'Template') {
    label = 'Choose';
  }

  return (
    <UICardActions>
      <Stack
        width="100%"
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        style={{ padding: theme.spacing(0, 1, 1) }}
      >
        {spec.owner && <Owner owner={spec.owner} />}
        {variant !== CardVariant.minimal && (
          <LinkButton
            to={actionRoute ?? '#'}
            variant="outlined"
            color="primary"
            size="small"
            underline="none"
          >
            {label}
          </LinkButton>
        )}
      </Stack>
    </UICardActions>
  );
};
